import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatDate, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_AGENT_NAME,
	STR_AMOUNT,
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLOSE_REQUEST,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_COULD_NOT_FETCH_DATA,
	STR_DISTRICT,
	STR_EXPECTED_REPAY_DATE,
	STR_FLOAT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_IS_LOANED,
	STR_IS_REJECTED,
	STR_IS_REPAID,
	STR_MENU_HOTELS,
	STR_NO,
	STR_NO_RECORD,
	STR_NORMAL_AGENT,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PHONE_NUMBER,
	STR_RECENT_REQUESTS,
	STR_REGION,
	STR_REPAID_DATE,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_REQUESTED_DATE,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SEND_MESSAGE_TO_AGENT,
	STR_SERVICE_PROVIDER,
	STR_STREET,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_SUPER_AGENT,
	STR_TILL_NAME,
	STR_TILL_NUMBER,
	STR_TILL_NUMBERS,
	STR_TILL_TYPE,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_AGENT_PROFILE,
	STR_WARD,
	STR_YES,
	STR_YOUR_REQUEST
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdInfoOutline, MdLocationPin, MdMessage, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate, MdVerified } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp, FaUserTag } from "react-icons/fa6";
import { IoPersonSharp } from "react-icons/io5";
import { RiMessage2Line } from "react-icons/ri";

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(null);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		await Promise.all([
			getData(),
		])
		setReady(true);
	}

	async function getData() {
		await callApi('get-float-loan-data', { id }).then((response) => {
			if(response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	} 

	
	useEffect(() => {
		init();
	}, [ id ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	
	if (ready && data) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingBottom: "calc(var(--topBarHeight) + 40px)",
					}}
					className="mNoScrollBar"
				>
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<div className="card">
									<div className="card-body">
										<div className="row">
											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_AMOUNT[appContext.language]}</label>
												<h6
													style={{
														fontSize: "20px"
													}}
												>
													{formatMoney(data.amountRequested)} TZS
												</h6>
											</div>

											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_AGENT_NAME[appContext.language]}</label>
												<h6
													style={{
														fontSize: "20px"
													}}
												>
													{data.agentName}
												</h6>
											</div>

											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_PHONE_NUMBER[appContext.language]}</label>
												<h6
													style={{
														fontSize: "20px"
													}}
												>
													{data.phone}
												</h6>
											</div>

											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_TILL_TYPE[appContext.language]}</label>
												<h6
													style={{
														fontSize: "20px"
													}}
												>
													{appContext.getTillTypeName(JSON.parse(data.till).tillType)}
												</h6>
											</div>

											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_TILL_NUMBER[appContext.language]}</label>
												<h6
													style={{
														fontSize: "20px"
													}}
												>
													{JSON.parse(data.till).tillNumber}
												</h6>
											</div>

											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_TILL_NAME[appContext.language]}</label>
												<h6
													style={{
														fontSize: "20px"
													}}
												>
													{JSON.parse(data.till).tillName}
												</h6>
											</div>


											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_IS_LOANED[appContext.language]}</label>
												<h6
													style={{
														fontSize: "20px"
													}}
												>
													{data.isLoaned === 'yes' ? STR_YES[appContext.language] : STR_NO[appContext.language]}
												</h6>
											</div>

											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_IS_REJECTED[appContext.language]}</label>
												<h6
													style={{
														fontSize: "20px"
													}}
												>
													{data.isRejected === 'yes' ? STR_YES[appContext.language] : STR_NO[appContext.language]}
												</h6>
											</div>
											
											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_IS_REPAID[appContext.language]}</label>
												<h6
													style={{
														fontSize: "20px"
													}}
												>
													{data.isPaid === 'yes' ? STR_YES[appContext.language] : STR_NO[appContext.language]}
												</h6>
											</div>

											<div className="col-md-6 mt-3 mb-3">
												<label className="form-label d-block">{STR_REQUESTED_DATE[appContext.language]}:</label>
												<h6
													style={{
														fontSize: "14px"
													}}
												>
													{formatDate(data.dateCreated)}
												</h6>
											</div>

											{
												(data.isLoaned === 'yes') ?
												<div className="col-md-6 mt-3 mb-3">
													<label className="form-label d-block">{STR_EXPECTED_REPAY_DATE[appContext.language]}:</label>
													<h6
														style={{
															fontSize: "14px"
														}}
													>
														{formatDate(data.dateToPay)}
													</h6>
												</div>
												:""
											}

											{
												(data.isPaid === 'yes') ?
												<div className="col-md-6 mt-3 mb-3">
													<label className="form-label d-block">{STR_REPAID_DATE[appContext.language]}:</label>
													<h6
														style={{
															fontSize: "14px"
														}}
													>
														{formatDate(data.datePaid)}
													</h6>
												</div>
												:""
											}

										</div>
									</div>

								</div>
							</div>

							
						</div>
					</div>
	
	
				</div>
			)
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}